export default __webpack_public_path__ + "static/media/004-yoga.7dfc4672.svg";